export default __webpack_public_path__ + "assets/audios/548ef8b74995d717d66173367361abfc.mp3";